exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-wrapper {\n    margin: 15px;\n}\n\n.card-separator {\n    margin: 15px 0;\n}\n\n.subtitle-with-mark {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n\n.github-logo {\n    max-height: 32px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/shane/workspace/website/website-client/src/app/portfolio/portfolio.component.css
// module id = ../../../../../src/app/portfolio/portfolio.component.css
// module chunks = main